(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('change-table', {
            parent: 'entity',
            url: '/change-table?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.changeTable.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/change-table/change-tables.html',
                    controller: 'ChangeTableController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('changeTable');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('change-table-detail', {
            parent: 'entity',
            url: '/change-table/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.changeTable.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/change-table/change-table-detail.html',
                    controller: 'ChangeTableDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('changeTable');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ChangeTable', function($stateParams, ChangeTable) {
                    return ChangeTable.get({id : $stateParams.id});
                }]
            }
        })
        .state('change-table.new', {
            parent: 'change-table',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/change-table/change-table-dialog.html',
                    controller: 'ChangeTableDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                nameGr: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('change-table', null, { reload: true });
                }, function() {
                    $state.go('change-table');
                });
            }]
        })
        .state('change-table.edit', {
            parent: 'change-table',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/change-table/change-table-dialog.html',
                    controller: 'ChangeTableDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ChangeTable', function(ChangeTable) {
                            return ChangeTable.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('change-table', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('change-table.delete', {
            parent: 'change-table',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/change-table/change-table-delete-dialog.html',
                    controller: 'ChangeTableDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ChangeTable', function(ChangeTable) {
                            return ChangeTable.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('change-table', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
